export function Groups({
  width = 20,
  height = 20,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.3346 16.6663V14.9997C18.3346 13.619 17.2153 12.4997 15.8346 12.4997C15.0383 12.4997 14.3289 12.872 13.8711 13.4521M14.168 16.6663V14.9997C14.168 14.4528 14.0626 13.9305 13.8711 13.4521M5.83464 16.6663V14.9997C5.83464 14.4528 5.93999 13.9305 6.13151 13.4521M1.66797 16.6663V14.9997C1.66797 13.619 2.78726 12.4997 4.16797 12.4997C4.96431 12.4997 5.67368 12.872 6.13151 13.4521M6.13151 13.4521C6.74589 11.9172 8.24698 10.833 10.0013 10.833C11.7556 10.833 13.2567 11.9172 13.8711 13.4521M12.5013 5.83301C12.5013 7.21372 11.382 8.33301 10.0013 8.33301C8.62059 8.33301 7.5013 7.21372 7.5013 5.83301C7.5013 4.4523 8.62059 3.33301 10.0013 3.33301C11.382 3.33301 12.5013 4.4523 12.5013 5.83301ZM17.5013 8.33301C17.5013 9.25348 16.7551 9.99967 15.8346 9.99967C14.9142 9.99967 14.168 9.25348 14.168 8.33301C14.168 7.41253 14.9142 6.66634 15.8346 6.66634C16.7551 6.66634 17.5013 7.41253 17.5013 8.33301ZM5.83464 8.33301C5.83464 9.25348 5.08844 9.99967 4.16797 9.99967C3.24749 9.99967 2.5013 9.25348 2.5013 8.33301C2.5013 7.41253 3.24749 6.66634 4.16797 6.66634C5.08844 6.66634 5.83464 7.41253 5.83464 8.33301Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
